import { ConvexProvider, ConvexReactClient } from "convex/react";
import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { ErrorBoundary } from "./components/ErrorBoundary";
import { CONVEX_URL } from "./lib/convex";

const convex = new ConvexReactClient(CONVEX_URL);

// QST-214: wrap the entire app in `ErrorBoundary` so an unexpected
// render-time exception (e.g. a Convex query throwing a payload
// shape we did not anticipate, an undefined-deref in a panel) shows
// the recoverable fallback instead of blanking the dashboard. The
// boundary lives outside `<ConvexProvider>` so even a Convex client
// init failure surfaces with the same UX.
ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <ErrorBoundary>
      <ConvexProvider client={convex}>
        <App />
      </ConvexProvider>
    </ErrorBoundary>
  </React.StrictMode>,
);
